import {useSelector} from 'react-redux';
import {selectUserSettingsData} from '@/redux/reducers/userSettingsReducer';
import {emitFactory} from '@/utils/events';
import useAuth from '@/hooks/use-auth/use-auth';

import {StyledButton} from '../styles';
import {StyledIcon} from './styles';
import {selectProductData} from '@/redux/reducers/productReducer';

const CollectionButton = ({product}) => {
  const auth = useAuth();
  const {collections_enabled: collectionsEnabled} = useSelector(selectUserSettingsData);
  const {collections: inCollections} = useSelector(selectProductData);

  return (
    <>
      {auth.isAuthenticated() && collectionsEnabled && (
        <StyledButton onClick={emitFactory('CLICK_ADD_TO_COLLECTION', product)}>
          <StyledIcon type="bookmark" fontSize={12} $active={inCollections?.length > 0} />

          <u>{inCollections?.length > 0 ? 'Added' : 'Add to'}</u>
        </StyledButton>
      )}
    </>
  );
};

export default CollectionButton;
